import { render } from "./ProjectPickerPage.vue?vue&type=template&id=187786e8"
import script from "./ProjectPickerPage.vue?vue&type=script&lang=js"
export * from "./ProjectPickerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__